module.exports = {"meta":{"count":1,"average":5,"reviewed":1,"limit":5,"sids":["DUB0"],"averageAsInteger":5,"averageAsPercentage":100},"reviews":{"3914896":{"cid":"3914896","comment":"Flawless, easy to use, no hassle no fuss. Bus arrived a few mins after we had parked. Simple","ip_address":"172.22.2.77","sid":"DUB0","comment_date":"2022-09-10 00:00:00","status":"1","score":"5","name":"Mrs Alexander","count":"0","total":"0","useful":"0","brand":"AP","travelled_with":"","usefulPercentage":"0","bookAgain":"","rating":"10","priority":" h1","product_name":"Parking at the Clayton hotel"}}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/reviews/parking/DUB.json
// module id = 211
// module chunks = 119